import React from "react";
import CustomModal from "./custom-modal";
import store from "../store";

export default function AuthError(){
  store.useRerenderIfChange(()=>[store.auth_error])
  if(!store.auth_error) return null
  return <CustomModal
  showModal
  hideCancel
  submitText="Logout"
  onSubmit={()=>{
    store.logout()
  }}
  >
    {store.auth_error}
  </CustomModal>
}